<template>
    <div class="row">
        <div class="form-inline col-md-2">

        </div>
        <div class="form-group col-md-3 mb-0">
            <v-autocomplete
                v-model="key"
                :items="$store.getters['CreateCohortStore/getPixelsKeys']"
                label="Key"
            ></v-autocomplete>
        </div><!--form-group-->
        <div class="form-group col-md-3 mb-0">
            <v-text-field
                v-model="value"
                label="Value"
            ></v-text-field>
        </div>
        <div class="form-group col-md-1 mb-0">
            <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        icon
                        v-bind="attrs"
                        v-on="on"
                        @click="removeInputField"
                    >
                        <v-icon color="danger lighten-1" class="tooltip-small">
                            mdi-minus-circle
                        </v-icon>
                    </v-btn>
                </template>
                <span>Remove Key & Value pair</span>
            </v-tooltip>
        </div>
    </div>
</template>

<script>
export default {
    name: "InputField",
    props: {
        indexItem: Number
    },
    data: () => ({

    }),
    methods: {
        removeInputField() {
            this.$store.commit('CreateCohortStore/REMOVE_KEY_AND_VALUE_PAIR', this.indexItem)
        }
    },
    created() {
        //
    },
    mounted() {
        //
    },
    computed: {
        key: {
            get() {
                return this.$store.getters['CreateCohortStore/getPixelKey'](this.indexItem)
            },
            set(value) {
                this.$store.commit('CreateCohortStore/SET_PIXELS_KEY', {
                    index: this.indexItem,
                    value: value
                })
            }
        },
        value: {
            get() {
                return this.$store.getters['CreateCohortStore/getPixelValue'](this.indexItem)
            },
            set(value) {
                this.$store.commit('CreateCohortStore/SET_PIXELS_VALUE', {
                    index: this.indexItem,
                    value: value
                })
            }
        },
    },
    watch: {
        //
    }
}
</script>

<style scoped>

</style>